import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Helper service that determines the correct URL for each API
 */
@Injectable({
  providedIn: 'root'
})
export class AppServiceHelperService {
  /**
   * Builds the URL to the service endpoint
   * @param service API / service
   * @param route Route within the API
   * @returns URL to the service endpoint
   */
  public getServiceEndpoint(service: 'pollux.api'
    | 'pollux.comparables.api'
    | 'pollux.projectValuation.api'
    | 'pollux.reportDesigner.api'
    | 'pollux.settings.api'
    | 'pollux.import.api'
    | 'pollux.data.transformation.api'
    | 'pollux.dataverse.api'
    | 'pollux.argus.integration.api'
    | 'pollux.pix.integration.api'
    | 'pollux.pixwintegration.capforce.api'
    | 'pollux.currencies.api'
    | 'pollux.casemanagement.api'
    | 'pollux.valorem.integration.api'
    , route: string): string {
    let ret = environment.serverBasePath;
    switch (service) {
      case 'pollux.api': {
        ret = environment.polluxApiUrl;
        break;
      }
      case 'pollux.comparables.api': {
        ret = environment.comparablesApiUrl;
        break;
      }
      case 'pollux.projectValuation.api': {
        ret = environment.projectValuationApiUrl;
        break;
      }
      case 'pollux.reportDesigner.api': {
        ret = environment.reportDesignerApiUrl;
        break;
      }
      case 'pollux.settings.api': {
        ret = environment.settingsApiUrl;
        break;
      }
      case 'pollux.import.api': {
        ret = environment.polluxImportApiUrl;
        break;
      }
      case 'pollux.data.transformation.api': {
        ret = environment.dataTransformationApiUrl;
        break;
      }
      case 'pollux.dataverse.api': {
        ret = environment.dataverseApiUrl;
        break;
      }
      case 'pollux.argus.integration.api': {
        ret = environment.argusIntegrationApiUrl;
        break;
      }
      case 'pollux.pix.integration.api': {
        ret = environment.pixIntegrationApiUrl;
        break;
      }
      case 'pollux.pixwintegration.capforce.api': {
        ret = environment.pixWIntegrationCapforceApiUrl;
        break;
      }
      case 'pollux.currencies.api': {
        ret = environment.currenciesApiUrl;
        break;
      }
      case 'pollux.casemanagement.api': {
        ret = environment.caseManagementApiUrl;
        break;
      }
      case 'pollux.valorem.integration.api': {
        ret = environment.pixWIntegrationValoremApiUrl;
        break;
      }
      default: {
        console.error('Invalid API configuration: Service endpoint for ' + service + ' is not defined!');
      }
    }

    if (!ret.endsWith('/')) {
      ret += '/';
    }

    ret += 'api/v2/';

    if (!ret.endsWith('/')) {
      ret += '/';
    }

    ret += route;

    return ret;
  }
}
